import { Reveal, Overline } from "./Reveal";
import { DURATIONS, TRAVEL, WORKING_HOURS, FAQS } from "./data";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { Info, Clock, Car, Timer } from "lucide-react";

export const Pricing = () => (
  <section id="preise" className="relative bg-[#fafafa] text-[#111] py-24 sm:py-36" data-testid="pricing">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline className="text-neutral-500">03 — Preise & Anfahrt</Overline>
      </Reveal>

      <div className="grid grid-cols-12 gap-10 lg:gap-16 mt-8">
        {/* Prices + travel + hours */}
        <div className="col-span-12 lg:col-span-6">
          <Reveal>
            <h2 className="font-grotesk font-medium text-3xl sm:text-4xl tracking-tight leading-[1.05]">
              Faire Festpreise, transparent kalkuliert.
            </h2>
          </Reveal>

          {/* Behandlung */}
          <Reveal delay={0.1}>
            <div className="mt-8">
              <div className="flex items-center gap-2 font-grotesk text-xs tracking-[0.2em] uppercase text-neutral-500">
                <Timer size={15} className="text-[var(--pmr-red)]" /> Behandlung
              </div>
              <div className="mt-4 divide-y divide-neutral-200 border-t border-neutral-200">
                {DURATIONS.map((d) => (
                  <div key={d.value} className="flex items-center justify-between py-4" data-testid={`price-${d.value}`}>
                    <div className="font-grotesk font-semibold text-lg">{d.label}</div>
                    <div className="font-display font-black text-2xl silver-text-dark">{d.price}</div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          {/* Anfahrt */}
          <Reveal delay={0.15}>
            <div className="mt-10">
              <div className="flex items-center gap-2 font-grotesk text-xs tracking-[0.2em] uppercase text-neutral-500">
                <Car size={15} className="text-[var(--pmr-red)]" /> Anfahrt (Hausbesuch)
              </div>
              <div className="mt-4 divide-y divide-neutral-200 border-t border-neutral-200">
                {TRAVEL.map((t) => (
                  <div key={t.area} className="flex items-center justify-between py-4" data-testid={`travel-${t.area}`}>
                    <div className="font-body text-[15px]">{t.area}</div>
                    <div className={`font-grotesk font-bold ${t.cost === "inklusive" ? "text-emerald-600" : "text-[var(--pmr-red)]"}`}>{t.cost}</div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          {/* Arbeitszeiten */}
          <Reveal delay={0.2}>
            <div className="mt-10 rounded-sm bg-neutral-900 text-neutral-200 p-6">
              <div className="flex items-center gap-2 font-grotesk text-xs tracking-[0.2em] uppercase text-neutral-400">
                <Clock size={15} className="text-[var(--pmr-red)]" /> Termine möglich
              </div>
              <div className="mt-4 space-y-2">
                {WORKING_HOURS.map((w) => (
                  <div key={w.day} className="flex items-center justify-between font-body text-sm">
                    <span className="text-neutral-300">{w.day}</span>
                    <span className="font-semibold text-white">{w.time}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.25}>
            <p className="mt-6 flex gap-3 font-body text-sm text-neutral-500">
              <Info size={16} className="shrink-0 mt-0.5 text-[var(--pmr-red)]" />
              P.M.R. ist eine Privatpraxis. Abrechnung privat, über private Krankenversicherung /
              Beihilfe oder als Selbstzahler.
            </p>
          </Reveal>
        </div>

        {/* FAQ */}
        <div className="col-span-12 lg:col-span-6">
          <Reveal>
            <Overline className="text-neutral-500">Häufige Fragen</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="mt-6 w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-neutral-200">
                  <AccordionTrigger className="font-grotesk font-medium text-lg text-left hover:no-underline py-6" data-testid={`faq-trigger-${i}`}>
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="font-body text-[15px] text-neutral-600 leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
